import React from 'react'
import FAQContainer from '../../components/commonTools/faq'

const FAQ = (props) => (
  <>
    <h1 className="page-title faq-page-title">
      FAQs
    </h1>
    <FAQContainer turnTo={(path) => props.history.push(path)} />
  </>
)

export default FAQ
